import attendances from "./attendance";
import contracts from "./contracts";
import files from "./files"
import forms from "./forms";
import places from "./places";

export default {
    attendances,
    contracts,
    files,
    forms,
    places
};
